// DS: i5.1
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const CommentOutline: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="M14 1a1 1 0 0 1 .993.884L15 2v7.086a1 1 0 0 1-.206.607l-.087.1-1.914 1.914c-.156.156-.36.255-.576.284l-.131.009H9l-1.703 2.555a1 1 0 0 1-.708.437L5 15a1 1 0 0 1-.993-.884L4 14v-2H2a1 1 0 0 1-.993-.884L1 11V3.914a1 1 0 0 1 .206-.607l.087-.1 1.914-1.914c.156-.156.36-.255.576-.284L3.914 1zM3 4.328V10h3v2.893L7.93 10h3.74L13 8.67V3H4.328z"></path>
      </svg>
    </IconWrap>
  );
};
CommentOutline.displayName = 'CommentOutline';

export default CommentOutline;
